import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminCreateWorkorderComponent } from "../admin-create-workorder/admin-create-workorder.component";
import { AdminDoTruckownerComponent } from "../admin-do-truckowner/admin-do-truckowner.component";
import { AdminEditWorkorderComponent } from "../admin-edit-workorder/admin-edit-workorder.component";
import { AdminNotifyDriverComponent } from "../admin-notify-driver/admin-notify-driver.component";
import { AdminService } from "../admin.service";
import { AdminViewWorkOrderComponent } from "../admin-view-work-order/admin-view-work-order.component";
import { AdminEditWorkOrderComponent } from "../admin-edit-work-order/admin-edit-work-order.component";
import { AdminCorporateNotifyDriverComponent } from "../admin-corporate-notify-driver/admin-corporate-notify-driver.component";

@Component({
  selector: "app-admin-workorder",
  templateUrl: "./admin-workorder.component.html",
  styleUrls: ["./admin-workorder.component.css"],
})
export class AdminWorkorderComponent implements OnInit {
  matdialogref!: MatDialogRef<AdminCorporateNotifyDriverComponent>;
  createdialogref: MatDialogRef<AdminCreateWorkorderComponent>;
  dodialogref: MatDialogRef<AdminDoTruckownerComponent>;
  editDialogref: MatDialogRef<AdminEditWorkorderComponent>;
  viewdialogref: MatDialogRef<AdminViewWorkOrderComponent>;
  editsdialogref: MatDialogRef<AdminEditWorkOrderComponent>;

  token: any;
  taxArray: any = [];
  s9Array: any = [];
  customerArray: any = [];
  driverArray: any = [];
  exemptedArray: any = [];
  taxDeleteId: any = [];
  ongoing: boolean = true;
  selectedWOType: any = "present_work_order";
  s9: boolean = true;
  customer: boolean = false;
  driver: boolean = false;
  exempted: boolean = false;
  taxSelect: boolean = true;
  taxCancel: boolean = false;
  taxDelete: boolean = false;
  CancelWO: boolean = false;
  DeleteAction: boolean = false;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  selectedType: string;
  checkBox: boolean = false;
  customerCheckBox: boolean = false;
  driverCheckBox: boolean = false;
  exemptCheckBox: boolean = false;
  SelectedItems: number = 0;
  document_array: any = [];
  total_cat_count: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  btn1: boolean = true;
  workorderArray: any = [];
  truckCtgyData: any;
  selectWO: boolean = true;
  deleteWO: boolean = false;
  selectedWOId: any;
  WoCreate: boolean = true;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  searchWorkOrder: any = -1;
  perPage: any = 10;
  loading: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  socketTimer: any;
  intervalId: any;

  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private matDialogue: MatDialog,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    let triptype = "workorder";
    localStorage.setItem("tripType", triptype);
    const savedPage = sessionStorage.getItem("lastWorderOrderFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;
    this.workOrder(this.searchWorkOrder);
    // this.pagination(1);
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.previousValue = input.value;
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.clear_Btn) {
      this.search_btn = true;
      this.clear_Btn = false;
    }

    this.isInputValid = value.trim().length >= 3;

    if (value.length === 0) {
      if (this.searchWorkOrder !== -1) {
        this.callApi();
      }
    }
  }

  private callApi() {
    this.searchWorkOrder = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.workOrder(this.searchWorkOrder);
  }

  getTripsList(selectedTripType: any) {
    this.selectedWOType = selectedTripType;
    // Save tripType to localStorage
    localStorage.setItem("lastTripType", this.selectedWOType);
    if (this.selectedWOType == "present_work_order") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.workOrder(this.searchWorkOrder);
      this.document_array = [];
    } else if (this.selectedWOType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.workOrder(this.searchWorkOrder);
      this.document_array = [];
    } else if (this.selectedWOType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.workOrder(this.searchWorkOrder);
      this.document_array = [];
    }
  }
  select(type: any) {
    if (type == "s9") {
      this.customer = false;
      this.driver = false;
      this.exempted = false;
      this.taxCancel = false;
      this.taxDelete = false;
      this.taxSelect = true;
      this.s9 = true;
      this.selectedType = type;
    } else if (type == "customer") {
      this.s9 = false;
      this.driver = false;
      this.exempted = false;
      this.taxCancel = false;
      this.taxDelete = false;
      this.taxSelect = true;
      this.customer = true;
      this.selectedType = type;
    } else if (type == "driver") {
      this.s9 = false;
      this.customer = false;
      this.exempted = false;
      this.taxCancel = false;
      this.taxDelete = false;
      this.taxSelect = true;
      this.driver = true;
      this.selectedType = type;
    } else if (type == "exempted") {
      this.s9 = false;
      this.customer = false;
      this.driver = false;
      this.taxCancel = false;
      this.taxDelete = false;
      this.taxSelect = true;
      this.exempted = true;
      this.selectedType = type;
    }
  }

  workOrder(type: any) {
    this.searchWorkOrder = type;
    this.loading = true;
    this.services
      .workOrderList(
        this.token,
        this.selectedWOType,
        this.searchWorkOrder,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          this.workorderArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.workorderArray = [];
          this.last_page = 1;

          if (error.status == 404) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            location.reload();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  getCityName(address: string): string {
    // Regular expression to capture city name before the state and postal code
    const cityRegex = /,\s*([\w\s]+),\s*[\w\s]+ \d{6},/;
    const match = address.match(cityRegex);
    return match ? match[1].trim() : ""; // Returns the city name if found, else empty string
  }

  CreateWorkorder(type: any) {
    this.createdialogref = this.matDialogue.open(
      AdminCreateWorkorderComponent,
      {
        width: "80vw",

        height: "auto", // Allows the dialog height to adjust based on its content
        maxHeight: "80vh", // Ensures the dialog doesn’t exceed 80% of the viewport height        autoFocus: false,
        data: type,
      }
    );
    this.createdialogref.afterClosed().subscribe((x) => {
      if (x && x.event === "Success") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  addWorkOrder(type: any) {    
    // Get the current time
    const currentTime = Date.now();

    // Extract expiry time from the workorder
    const expiryTime = type.workorder_expiry_time;
    const timeDifference = expiryTime - currentTime;

    // Check if the bid is still running
    if (timeDifference > 0) {
      this.snackBar.open(
        "Bid is running. Please wait until it expires.",
        "Close",
        { duration: 3000 }
      );
      return;
    }

    // If expired, update the timer display
    this.socketTimer = { remainingTime: "Expired" };
    this.matdialogref = this.matDialogue.open(
      AdminCorporateNotifyDriverComponent,
      {
        width: "80vw", // The width is still fixed to 80% of the viewport width
        height: "auto", // Allows the dialog height to adjust based on its content
        maxHeight: "80vh", // Ensures the dialog doesn’t exceed 80% of the viewport height
        autoFocus: false,
        data: type,
      }
    );
    this.matdialogref.afterClosed().subscribe((x) => {
      if (x && x.event !== "close") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  Editworkorder(type: any) {
    // Get the current time
    const currentTime = Date.now();

    // Extract expiry time from the workorder
    const expiryTime = type.workorder_expiry_time;
    const timeDifference = expiryTime - currentTime;

    // Check if the bid is still running
    if (timeDifference > 0) {
      this.snackBar.open(
        "Bid is running. Please wait until it expires.",
        "Close",
        { duration: 3000 }
      );
      return;
    }

    // If expired, update the timer display
    this.socketTimer = { remainingTime: "Expired" };

    this.editDialogref = this.matDialogue.open(AdminEditWorkorderComponent, {
      width: "80vw",

      height: "auto", // Allows the dialog height to adjust based on its content
      maxHeight: "80vh", // Ensures the dialog doesn’t exceed 80% of the viewport height      autoFocus: false,
      data: type,
    });
    this.editDialogref.afterClosed().subscribe((x) => {
      if (x && x.event === "Success") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  doWorkOrder(type: any) {
    // Get the current time
    const currentTime = Date.now();

    // Extract expiry time from the workorder
    const expiryTime = type.workorder_expiry_time;
    const timeDifference = expiryTime - currentTime;

    // Check if the bid is still running
    if (timeDifference > 0) {
      this.snackBar.open(
        "Bid is running. Please wait until it expires.",
        "Close",
        { duration: 3000 }
      );
      return;
    }

    // If expired, update the timer display
    this.socketTimer = { remainingTime: "Expired" };

    this.dodialogref = this.matDialogue.open(AdminDoTruckownerComponent, {
      width: "80vw",

      height: "auto", // Allows the dialog height to adjust based on its content
      maxHeight: "80vh", // Ensures the dialog doesn’t exceed 80% of the viewport height      autoFocus: false,
      data: type,
    });
    this.dodialogref.afterClosed().subscribe((x) => {
      if (x && x.event !== "close") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  close() {
    this.matdialogref.close();
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastWorderOrderFetchPage", newPage.toString());

    this.workOrder(this.searchWorkOrder);
  }

  selectedWO() {
    this.selectWO = false;
    this.WoCreate = false;
    this.searchButton = false;
    this.deleteWO = true;
    this.checkBox = true;
    this.CancelWO = true;
  }

  matItem(item: any) {
    this.selectedWOId = item._id;
  }

  deleteWorkOrder() {
    if (this.selectedWOId == undefined) {
      this.snackBar.open("Please Select WO ", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.services.woorkOrderDelete(this.selectedWOId, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.snackBar.open("Work Order Deleted Sucessfully", "Success", {
            duration: 5000,
          });
          this.workOrder(this.searchWorkOrder);
          this.deleteWO = false;
          this.checkBox = false;
          this.selectWO = true;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          location.reload();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  cancelWO() {
    this.searchWorkOrder = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.workOrder(this.searchWorkOrder);
    this.selectWO = true;
    this.deleteWO = false;
    this.CancelWO = false;
    this.checkBox = false;
    this.DeleteAction = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.SelectedItems = 0;
    this.WoCreate = true;
    this.search_btn = false;
    this.clear_Btn = false;
    this.isInputValid = false;
    this.previousValue = "";
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.WoCreate = false;
    this.deleteWO = true;
    this.CancelWO = true;
    this.selectWO = false;
    this.checkBox = true;
    this.search_btn = true;
    this.clear_Btn = false;
    this.isInputValid = false;
    this.previousValue = "";
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  search(value: string) {
    if (value == "") {
      this.startPage = 1;
      this.searchWorkOrder = "";
      this.workOrder(this.searchWorkOrder);
      this.searchButton = true;
      this.WoCreate = true;
      this.toggleSearch = false;
      this.deleteWO = false;
      this.CancelWO = false;
      this.selectWO = true;
      this.checkBox = false;
    } else {
      this.startPage = 1;

      this.search_btn = false;
      this.clear_Btn = true;
      this.workOrder(value);
    }
  }

  viewWorkOrder(item: any) {
    this.viewdialogref = this.matDialogue.open(AdminViewWorkOrderComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
      data: item,
    });
    this.viewdialogref.afterClosed().subscribe((x) => {
      if (x && x.event !== "close") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  EditsWorkOrder(item: any) {
    // Get the current time
    const currentTime = Date.now();

    // Extract expiry time from the workorder
    const expiryTime = item.workorder_expiry_time;
    const timeDifference = expiryTime - currentTime;

    // Check if the bid is still running
    if (timeDifference > 0) {
      this.snackBar.open(
        "Bid is running. Please wait until it expires.",
        "Close",
        { duration: 3000 }
      );
      return;
    }

    // If expired, update the timer display
    this.socketTimer = { remainingTime: "Expired" };
    this.editsdialogref = this.matDialogue.open(AdminEditWorkOrderComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
      data: item,
    });
    this.editsdialogref.afterClosed().subscribe((x) => {
      if (x && x.event === "Success") {
        this.workOrder(this.searchWorkOrder);
      }
    });
  }

  // timer //

  startCountdown(timeDifference: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId); // Clear existing interval
    }

    if (!timeDifference || isNaN(timeDifference) || timeDifference <= 0) {
      this.socketTimer = { remainingTime: "Expired" };
      return;
    }

    // Store the expected end time
    const endTime = Date.now() + timeDifference;

    this.intervalId = setInterval(() => {
      const currentTime = Date.now();
      const remainingTime = endTime - currentTime;

      if (remainingTime <= 0) {
        clearInterval(this.intervalId);
        this.intervalId = null; // Reset timer reference
        this.socketTimer = { remainingTime: "Expired" };
        return;
      }

      const totalMinutes = Math.floor(remainingTime / (1000 * 60));
      const seconds = Math.floor((remainingTime / 1000) % 60);
      const formattedMinutes = String(totalMinutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      this.socketTimer = {
        remainingTime: `${formattedMinutes}:${formattedSeconds}`,
      };
    }, 1000);
  }
}
